// extracted by mini-css-extract-plugin
module.exports = {"root":"settings-menu_root__8zhkq"};